/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Smnotesbody2Inputs */

const zh_landing_admin_smnotesbody2 = /** @type {(inputs: Landing_Admin_Smnotesbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提炼要点，化繁为简`)
};

const en_landing_admin_smnotesbody2 = /** @type {(inputs: Landing_Admin_Smnotesbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key points, simplified`)
};

const es_landing_admin_smnotesbody2 = /** @type {(inputs: Landing_Admin_Smnotesbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntos clave, simplificados`)
};

/**
* | output |
* | --- |
* | "Key points, simplified" |
*
* @param {Landing_Admin_Smnotesbody2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_smnotesbody2 = /** @type {((inputs?: Landing_Admin_Smnotesbody2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Smnotesbody2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_smnotesbody2(inputs)
	if (locale === "en") return en_landing_admin_smnotesbody2(inputs)
	return es_landing_admin_smnotesbody2(inputs)
});
export { landing_admin_smnotesbody2 as "landing_admin_smNotesBody" }